import type { ReactNode } from "react";
import { ScrollView, StyleSheet } from "react-native";

import {
  radii,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function ScrollCard({
  children,
  maxHeight = 160,
}: {
  children: ReactNode;
  maxHeight?: number;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <ScrollView style={[stylesheet.card, { maxHeight }]}>{children}</ScrollView>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    card: {
      padding: spacing.s,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: radii.xs,
      backgroundColor: colors.elevated,
    },
  });
